export default "__VITE_ASSET__CrX2hv0m__"